/* eslint-disable no-magic-numbers */
import Vue from "vue";

Vue.filter("capitalize", function (value) {
	if (!value)
		return "";

	value = value.toString();
	return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("round", function (number) {
	// check if number contains decimals, round it to two decimal points
	if (number % 1 !== 0)
		number = number.toFixed(1);


	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});


Vue.filter("roundNumber", function(number) {
	return Math.round(number);
});
